export const urlBase = '/.netlify/functions/';
export async function executeBackendFunction(functionName, queryParameters) {
    if (functionName.length === 0) {
        throw new Error('Cannot process empty query function.');
    }
    const functionUrl = generateFunctionUrl(functionName, queryParameters);
    console.log(`Querying ${functionUrl}...`);
    const response = await fetch(functionUrl);
    if (response.ok) {
        const responseContent = await response.json();
        console.log(`Received response from ${functionUrl}!`);
        return responseContent;
    }
    else {
        console.error(`Error encountered: `, response);
        return false;
    }
}
export function generateFunctionUrl(functionName, queryParameters) {
    let queryParameterString = '';
    if (queryParameters && queryParameters.length > 0) {
        let firstParameterSet = false;
        for (const parameter of queryParameters) {
            const encodedName = encodeURIComponent(parameter.name);
            const encodedValue = encodeURIComponent(parameter.value);
            const delimiter = firstParameterSet ? '&' : '?';
            queryParameterString += `${delimiter}${encodedName}=${encodedValue}`;
            firstParameterSet = true;
        }
    }
    return `${urlBase}${functionName}${queryParameterString}`;
}
//# sourceMappingURL=NetlifyUtilities.js.map